module.exports = {
	apiURL: 'https://api.odedim.com/',
	cdnUrl: 'https://cdnd.odedim.com/',
	captchaSiteKey: '6Lc8P8cZAAAAAEsu1RdaJ0h4h8MnAyfmeTaZ7Nhv',
	sentryDSN: 'https://beeac0218abf320499de6c2e903eecf9@sentry.pstv.co/15',
	// maps: {
	// 	apiKey: 'AIzaSyDrR_pXlUq_qCymZfm7aanRCaqAO7rOwFg',
	// },
}
